export default __webpack_public_path__ + "89fd03731a9d4f6a61768aad0cc1a795.svg";